import {ActionList, type ActionListItemProps} from '@primer/react'
import type {ComponentType, ReactNode} from 'react'

interface ActionBarItemSharedProps {
  children: ReactNode
  leadingVisual?: ComponentType
  trailingVisual?: ComponentType
  description?: ReactNode
  active?: boolean
}

export type ActionBarItemProps =
  | (ActionBarItemSharedProps & {
      href: string
      onClick?: never
    })
  | (ActionBarItemSharedProps & {
      href?: never
      onClick: NonNullable<ActionListItemProps['onSelect']>
    })

export function ActionBarItem({
  children,
  href,
  leadingVisual: LeadingVisual,
  trailingVisual: TrailingVisual,
  description,
  active,
  onClick,
}: ActionBarItemProps) {
  if (href !== undefined) {
    return (
      <ActionList.LinkItem href={href} active={active}>
        {LeadingVisual && (
          <ActionList.LeadingVisual>
            <LeadingVisual />
          </ActionList.LeadingVisual>
        )}
        {children}
        {description !== undefined && description !== null && (
          <ActionList.Description>{description}</ActionList.Description>
        )}
        {TrailingVisual && (
          <ActionList.TrailingVisual>
            <TrailingVisual />
          </ActionList.TrailingVisual>
        )}
      </ActionList.LinkItem>
    )
  }

  return (
    <ActionList.Item active={active} aria-pressed={active === undefined ? undefined : active} onSelect={onClick}>
      {LeadingVisual && (
        <ActionList.LeadingVisual>
          <LeadingVisual />
        </ActionList.LeadingVisual>
      )}
      {children}
      {description !== undefined && description !== null && (
        <ActionList.Description>{description}</ActionList.Description>
      )}
      {TrailingVisual && (
        <ActionList.TrailingVisual>
          <TrailingVisual />
        </ActionList.TrailingVisual>
      )}
    </ActionList.Item>
  )
}

ActionBarItem.displayName = 'ActionBarItem'
